import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import DashboardLayout from "@/layouts/DashboardLayout";
import Overview from "@/pages/Overview";
import Inbox from "@/pages/Inbox";
import Knowledge from "@/pages/Knowledge";
import Simulator from "@/pages/Simulator";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/lib/auth";

function RequireAuth({ children }) {
  const { user, loading, configured } = useAuth();
  const location = useLocation();
  if (!configured) return children; // Auth nicht konfiguriert → durchlassen
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Lade…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <RequireAuth>
                  <DashboardLayout />
                </RequireAuth>
              }
            >
              <Route path="/" element={<Overview />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/inbox/:id" element={<Inbox />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/simulator" element={<Simulator />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            fontFamily: "'DM Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
